var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 774,
    height: 600,
    viewBox: "0 0 774 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "No Chat History"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.914 0C348.391 0 283.572 24.4463 232.39 65.3471H149.671C138.924 65.3471 130.131 74.169 130.131 84.9512C130.131 95.7335 138.924 104.555 149.671 104.555H191.769H204.105C214.852 104.555 223.645 113.377 223.645 124.159C223.645 129.544 221.444 134.458 217.9 138C214.37 141.555 209.472 143.764 204.105 143.764H177.786H163.254H92.3537C81.6067 143.764 72.8137 152.585 72.8137 163.368C72.8137 174.15 81.6067 182.972 92.3537 182.972H143.111C127.789 219.098 119.302 258.849 119.302 300.597C119.302 315.744 120.422 330.63 122.572 345.176C123.47 351.254 124.552 357.279 125.815 363.238C162.681 357.579 201.786 353.031 242.612 349.712L245.686 352.521L248.578 349.241C297.623 345.412 349.105 343.373 402.201 343.373C515.012 343.373 620.58 352.574 710.841 368.571C714.319 353.436 716.664 337.871 717.771 321.952C718.279 314.895 718.527 307.772 718.527 300.597C718.527 134.576 584.392 0 418.914 0",
    fill: "#F1F2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0219 142.857H21.1802C10.2939 142.857 1.38684 151.857 1.38684 162.857C1.38684 173.857 10.2939 182.857 21.1802 182.857H33.0219C43.9083 182.857 52.8153 173.857 52.8153 162.857C52.8153 151.857 43.9083 142.857 33.0219 142.857",
    fill: "#F1F2F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2630_24069",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 343,
    width: 648,
    height: 257
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M772.613 343.806V600H449.012H125.411V343.806H772.613V343.806Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2630_24069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M772.613 442.858C772.613 453.572 763.823 462.338 753.078 462.338H628.299C622.933 462.338 618.038 464.533 614.508 468.065C610.966 471.585 608.764 476.468 608.764 481.818C608.764 492.533 617.554 501.299 628.299 501.299H651.482C656.846 501.299 661.744 503.494 665.274 507.026C668.816 510.546 671.017 515.429 671.017 520.779C671.017 531.494 662.226 540.26 651.482 540.26H598.177C548.1 577.766 485.875 600 418.439 600C274.413 600 154.128 498.637 125.411 363.546C162.267 357.923 201.364 353.403 242.179 350.104L245.252 352.897L248.144 349.637C297.176 345.832 348.647 343.806 401.73 343.806C514.513 343.806 620.055 352.949 710.295 368.845C705.907 387.78 699.708 406.013 691.894 423.377H753.078C758.457 423.377 763.328 425.572 766.87 429.104C770.412 432.624 772.613 437.507 772.613 442.858",
    fill: "#E8EBF2"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M715.672 321.063C714.567 337.285 712.225 353.147 708.751 368.57C618.61 352.268 513.182 342.894 400.521 342.894C347.495 342.894 296.082 344.97 247.102 348.872L281.069 309.516L333.909 343.998L405.439 324.248L528.49 342.894L581.91 324.248L595.44 342.894L627.72 318.934L657.885 346.581L705.46 308.57L715.672 321.063Z",
    fill: "#E0E2EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.102 348.57L244.331 351.428L241.388 348.98C243.283 348.832 245.193 348.696 247.102 348.57",
    fill: "#F1F2F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.386 349.308C200.574 352.633 161.481 357.189 124.628 362.857C123.365 356.888 122.284 350.853 121.386 344.766L184.555 297.143L241.386 349.308Z",
    fill: "#E0E2EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.101 447.142C527.101 452.665 477.212 457.142 415.672 457.142C354.131 457.142 304.244 452.665 304.244 447.142C304.244 441.621 354.131 437.143 415.672 437.143C477.212 437.143 527.101 441.621 527.101 447.142",
    fill: "#D8DBEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M709.958 539.999V539.999C698.958 539.999 689.958 530.999 689.958 519.999C689.958 508.999 698.958 499.999 709.958 499.999C720.958 499.999 729.958 508.999 729.958 519.999C729.958 530.999 720.958 539.999 709.958 539.999",
    fill: "#E1E3EF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 26818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.572 355.873C215.572 372.065 220.75 387.139 229.65 399.828L220.205 433.682L256.982 424.734C270.808 432.776 287.204 437.456 304.806 437.456C354.09 437.456 394.04 400.929 394.04 355.873C394.04 310.813 354.09 274.285 304.806 274.285C255.522 274.285 215.572 310.813 215.572 355.873Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.747 355.87C327.747 361.502 332.311 366.067 337.944 366.067C343.576 366.067 348.144 361.502 348.144 355.87C348.144 350.239 343.576 345.671 337.944 345.671C332.311 345.671 327.747 350.239 327.747 355.87",
    fill: "#BEC0D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.152 355.87C297.152 361.502 301.717 366.067 307.35 366.067C312.981 366.067 317.548 361.502 317.548 355.87C317.548 350.239 312.981 345.671 307.35 345.671C301.717 345.671 297.152 350.239 297.152 355.87Z",
    fill: "#BEC0D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.457 355.87C261.457 361.502 266.022 366.067 271.655 366.067C277.286 366.067 281.853 361.502 281.853 355.87C281.853 350.239 277.286 345.671 271.655 345.671C266.022 345.671 261.457 350.239 261.457 355.87",
    fill: "#BEC0D6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group 26819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M592.2 309.571C605.731 289.902 613.482 266.578 613.281 241.617C612.728 172.19 550.879 116.401 475.138 117.005C399.398 117.611 338.449 174.384 339.004 243.811C339.558 313.237 401.408 369.028 477.147 368.423C504.208 368.207 529.378 360.817 550.533 348.243L607.119 361.567L592.2 309.571Z",
    fill: "url(#paint0_linear_2630_24069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.142 239.744C436.205 247.632 429.861 254.079 421.972 254.142C414.08 254.206 407.634 247.86 407.572 239.972C407.509 232.082 413.853 225.636 421.743 225.572C429.631 225.509 436.078 231.854 436.142 239.744",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.57 239.742C487.633 247.632 481.288 254.079 473.398 254.142C465.508 254.205 459.061 247.86 458.999 239.972C458.935 232.082 465.28 225.635 473.17 225.572C481.059 225.509 487.506 231.854 487.57 239.742",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539 239.742C539.063 247.631 532.719 254.078 524.829 254.142C516.939 254.205 510.492 247.86 510.43 239.97C510.366 232.08 516.711 225.635 524.601 225.572C532.489 225.508 538.936 231.854 539 239.742",
    fill: "#FEFEFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2630_24069",
    x1: 384.899,
    y1: 175.286,
    x2: 576.899,
    y2: 319.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75CA8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09A98B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbles);
export default __webpack_public_path__ + "static/media/chat-bubbles.124bdbfb.svg";
export { ForwardRef as ReactComponent };